export default __webpack_public_path__ + "static/media/Asi_lo_hacemos.0f4b1157.png";